import { AsyncApiWebComponent } from './AsyncApiWebComponent';
export default AsyncApiWebComponent;
